import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../services/api";

const AdminVouchers = () => {
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState({
    code: "",
    type: "percent",
    value: 0,
    minOrder: 0,
    startDate: "",
    expiryDate: "",
    isActive: true,
    isSpinPrize: false,
    usageType: "promotion",
    quantity: 0,
    giftName: "",
    description: "",
  });
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [searchUser, setSearchUser] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUserForGift, setSelectedUserForGift] = useState(null);
  const [gifting, setGifting] = useState(false);

  useEffect(() => {
    fetchVouchers();
  }, []);

  const handleSearchUser = async (term) => {
    if (!term || term.length < 2) {
      setUsers([]);
      return;
    }
    try {
      setLoading(true);
      const res = await api.get("/admin/users");
      const filtered = (res.data || []).filter(
        (u) =>
          u.email.toLowerCase().includes(term.toLowerCase()) ||
          u.name.toLowerCase().includes(term.toLowerCase()),
      );
      setUsers(filtered);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleGiftVoucher = async () => {
    if (!selectedUserForGift || !selectedVoucher) return;
    try {
      setGifting(true);
      await api.post("/admin/vouchers/gift", {
        userId: selectedUserForGift._id,
        voucherId: selectedVoucher._id,
      });
      toast.success(`Đã tặng voucher thành công cho ${selectedUserForGift.name}`);
      setShowGiftModal(false);
      setSelectedUserForGift(null);
    } catch (err) {
      toast.error(err.response?.data || "Lỗi khi tặng voucher");
    } finally {
      setGifting(false);
    }
  };

  const fetchVouchers = async () => {
    try {
      setLoading(true);
      const res = await api.get("/vouchers");
      setVouchers(res.data || []);
    } catch (err) {
      console.error(err);
      toast.error("Không thể lấy danh sách voucher");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...selectedVoucher,
        value: parseFloat(selectedVoucher.value),
        minOrder: parseFloat(selectedVoucher.minOrder),
        quantity: parseInt(selectedVoucher.quantity) || 0,
        startDate: selectedVoucher.startDate
          ? new Date(selectedVoucher.startDate).toISOString()
          : new Date().toISOString(),
        expiryDate: selectedVoucher.expiryDate
          ? new Date(selectedVoucher.expiryDate).toISOString()
          : new Date().toISOString(),
      };

      if (selectedVoucher._id) {
        await api.put(`/vouchers/${selectedVoucher._id}`, payload);
        toast.success("Đã cập nhật voucher thành công!");
      } else {
        await api.post("/vouchers", payload);
        toast.success("Đã thêm voucher mới!");
      }
      setShowModal(false);
      fetchVouchers();
    } catch (err) {
      toast.error("Lỗi khi lưu voucher");
    }
  };

  const deleteVoucher = async (id) => {
    if (!window.confirm("Bạn có chắc chắn muốn xóa voucher này?")) return;
    try {
      await api.delete(`/vouchers/${id}`);
      toast.success("Đã xóa voucher");
      fetchVouchers();
    } catch (err) {
      toast.error("Lỗi khi xóa voucher");
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("vi-VN").format(amount) + "₫";
  };

  return (
    <div className="p-3 sm:p-6 lg:p-8 bg-gray-50 min-h-screen font-inter">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6 sm:mb-8">
        <div>
          <h1 className="text-xl sm:text-3xl font-black text-slate-800 tracking-tight">Voucher</h1>
          <p className="text-[10px] sm:text-sm text-slate-400 font-bold uppercase tracking-widest mt-1">
            Quản lý {vouchers.length} mã giảm giá & ưu đãi
          </p>
        </div>
        <button
          onClick={() => {
            setSelectedVoucher({
              code: "",
              type: "percent",
              value: 0,
              minOrder: 0,
              startDate: "",
              expiryDate: "",
              isActive: true,
              isSpinPrize: false,
              usageType: "promotion",
              quantity: 0,
              giftName: "",
              description: "",
            });
            setShowModal(true);
          }}
          className="flex items-center justify-center gap-2 px-6 py-2.5 sm:py-3.5 bg-blue-600 text-white rounded-2xl font-black text-sm hover:bg-blue-700 transition-all shadow-xl shadow-blue-100 active:scale-95"
        >
          <span className="material-symbols-outlined text-[20px]">add_circle</span>
          Thêm Voucher
        </button>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        {/* Desktop Table */}
        <div className="hidden lg:block overflow-x-auto">
          <table className="w-full text-left">
            <thead className="bg-gray-50/50 border-b border-gray-100">
              <tr>
                <th className="px-6 py-4 font-black text-[11px] text-slate-400 uppercase tracking-widest">Mã Code</th>
                <th className="px-6 py-4 font-black text-[11px] text-slate-400 uppercase tracking-widest">Loại hình</th>
                <th className="px-6 py-4 font-black text-[11px] text-slate-400 uppercase tracking-widest">Giá trị</th>
                <th className="px-6 py-4 font-black text-[11px] text-slate-400 uppercase tracking-widest">Đơn tối thiểu</th>
                <th className="px-6 py-4 font-black text-[11px] text-slate-400 uppercase tracking-widest">Số lượng</th>
                <th className="px-6 py-4 font-black text-[11px] text-slate-400 uppercase tracking-widest">Trạng thái</th>
                <th className="px-6 py-4 font-black text-[11px] text-slate-400 uppercase tracking-widest text-right">Thao tác</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {vouchers.map((v) => (
                <tr key={v._id} className="hover:bg-blue-50/10 transition-colors group">
                  <td className="px-6 py-4 font-black text-blue-600 tracking-tight">{v.code}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2.5 py-1 rounded-lg text-[10px] font-black uppercase tracking-wider ${
                      v.type === "gift" ? "bg-indigo-50 text-indigo-600" :
                      v.usageType === "promotion" ? "bg-red-50 text-red-600" :
                      "bg-amber-50 text-amber-600"
                    }`}>
                      {v.type === "gift" ? "Quà tặng" : 
                       v.usageType === "promotion" ? "Khuyến mãi" :
                       v.usageType === "luckywheel" || v.isSpinPrize ? "Vòng quay" : "Hệ thống"}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-sm font-black text-slate-800">
                      {v.type === "gift" ? v.giftName : 
                       v.type === "percent" ? `${v.value}%` : formatCurrency(v.value)}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-slate-400">{formatCurrency(v.minOrder)}</td>
                  <td className="px-6 py-4">
                    <span className="text-sm font-black text-blue-600">{v.quantity || 0}</span>
                  </td>
                  <td className="px-6 py-4">
                    <span className={`text-[10px] font-black uppercase tracking-widest ${v.isActive ? "text-green-600" : "text-slate-300"}`}>
                      {v.isActive ? "Hoạt động" : "Tắt"}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right">
                    <div className="flex justify-end gap-1">
                      <button
                        onClick={() => {
                          setSelectedVoucher(v);
                          setShowModal(true);
                        }}
                        className="w-8 h-8 flex items-center justify-center text-amber-500 hover:bg-amber-50 rounded-lg transition-all"
                        title="Chỉnh sửa"
                      >
                        <span className="material-symbols-outlined text-[18px]">edit</span>
                      </button>
                      <button
                        onClick={() => {
                          setSelectedVoucher(v);
                          setShowGiftModal(true);
                          setSearchUser("");
                          setUsers([]);
                        }}
                        className="w-8 h-8 flex items-center justify-center text-blue-600 hover:bg-blue-50 rounded-lg transition-all"
                        title="Tặng khách hàng"
                      >
                        <span className="material-symbols-outlined text-[18px]">card_giftcard</span>
                      </button>
                      <button
                        onClick={() => deleteVoucher(v._id)}
                        className="w-8 h-8 flex items-center justify-center text-red-500 hover:bg-red-50 rounded-lg transition-all"
                        title="Xóa"
                      >
                        <span className="material-symbols-outlined text-[18px]">delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile View */}
        <div className="lg:hidden divide-y divide-gray-50">
          {vouchers.map((v) => (
            <div key={v._id} className="p-4 space-y-3 hover:bg-gray-50/50 transition-colors">
              <div className="flex justify-between items-start">
                <div className="flex flex-col">
                  <span className="text-sm font-black text-blue-600 tracking-tight leading-none uppercase">{v.code}</span>
                  <span className="text-[9px] font-black text-slate-300 uppercase mt-1 tracking-widest">
                    {v.usageType === "promotion" ? "Hết hạn: " + (v.expiryDate ? new Date(v.expiryDate).toLocaleDateString() : "N/A") : "Voucher Quà tặng"}
                  </span>
                </div>
                <span className={`px-2 py-0.5 rounded-lg text-[9px] font-black uppercase tracking-wider ${
                  v.usageType === "promotion" ? "bg-red-50 text-red-600" :
                  v.usageType === "luckywheel" || v.isSpinPrize ? "bg-amber-50 text-amber-600" :
                  "bg-indigo-50 text-indigo-600"
                }`}>
                  {v.usageType === "promotion" ? "Sale" : v.usageType === "luckywheel" ? "Spin" : "Gift"}
                </span>
              </div>

              <div className="flex justify-between items-end">
                <div className="flex flex-col">
                  <span className="text-[14px] font-black text-slate-800">
                    {v.type === "percent" ? `Giảm ${v.value}%` : `Giảm ${formatCurrency(v.value)}`}
                  </span>
                  <span className="text-[10px] font-bold text-slate-400">Đơn từ: {formatCurrency(v.minOrder)}</span>
                </div>
                <div className="flex gap-1.5">
                  <button
                    onClick={() => {
                      setSelectedVoucher(v);
                      setShowModal(true);
                    }}
                    className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-50 text-amber-600 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-amber-100 transition-all"
                  >
                    <span className="material-symbols-outlined text-[14px]">edit</span>
                    Sửa
                  </button>
                  <button
                    onClick={() => {
                      setSelectedVoucher(v);
                      setShowGiftModal(true);
                      setSearchUser("");
                      setUsers([]);
                    }}
                    className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 text-blue-600 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-blue-100 transition-all"
                  >
                    <span className="material-symbols-outlined text-[14px]">send</span>
                    Tặng
                  </button>
                  <button
                    onClick={() => deleteVoucher(v._id)}
                    className="w-8 h-8 flex items-center justify-center bg-red-50 text-red-500 rounded-xl hover:bg-red-100 transition-all"
                  >
                    <span className="material-symbols-outlined text-[16px]">delete</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        {vouchers.length === 0 && !loading && (
          <div className="py-20 text-center text-slate-300 font-bold uppercase text-[10px] tracking-widest">
            Chưa có voucher nào
          </div>
        )}
      </div>

      {/* Voucher Modal - Full-screen Drawer on Mobile */}
      {showModal && (
        <div className="fixed inset-0 z-[100] flex sm:items-center justify-center p-0 sm:p-4 bg-slate-900/60 backdrop-blur-sm overflow-hidden">
          <div className="bg-white w-full max-w-xl h-full sm:h-auto sm:max-h-[90vh] sm:rounded-[32px] overflow-hidden shadow-2xl animate-modalUp flex flex-col">
            <div className="p-4 sm:p-6 bg-slate-900 text-white flex justify-between items-center shrink-0">
              <h3 className="text-sm sm:text-lg font-black uppercase tracking-widest flex items-center gap-3">
                <span className="w-8 h-8 sm:w-10 sm:h-10 rounded-xl bg-blue-500 flex items-center justify-center">
                  <span className="material-symbols-outlined text-white">confirmation_number</span>
                </span>
                {selectedVoucher._id ? "Cập nhật Voucher" : "Tạo Voucher Mới"}
              </h3>
              <button onClick={() => setShowModal(false)} className="w-10 h-10 rounded-full hover:bg-slate-800 flex items-center justify-center bg-slate-800">
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>
            
            <form onSubmit={handleSave} className="flex-1 overflow-y-auto p-4 sm:p-8 no-scrollbar bg-white flex flex-col gap-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="space-y-1.5">
                  <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Loại voucher</label>
                  <select
                    value={selectedVoucher.usageType === "promotion" && selectedVoucher.type !== "gift" ? "promo_special" : selectedVoucher.type}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "promo_special") {
                        setSelectedVoucher({ ...selectedVoucher, type: "percent", usageType: "promotion" });
                      } else if (val === "gift") {
                        setSelectedVoucher({ ...selectedVoucher, type: "gift", usageType: "gift" });
                      } else {
                        setSelectedVoucher({ ...selectedVoucher, type: val, usageType: "promotion" });
                      }
                    }}
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-2xl focus:ring-2 focus:ring-blue-500 outline-none text-sm font-bold text-slate-700 transition-all font-inter"
                  >
                    <option value="percent">🔥 Sale công khai (%)</option>
                    <option value="amount">💰 Giảm tiền mặt (₫)</option>
                    <option value="promo_special">🔖 Voucher Khuyến mãi (Hiện trang chủ)</option>
                    <option value="gift">🎁 Quà tặng vật phẩm</option>
                  </select>
                </div>

                <div className="space-y-1.5 animate-fadeIn">
                  {selectedVoucher.type === "gift" ? (
                    <>
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Tên quà tặng *</label>
                      <input
                        required
                        type="text"
                        value={selectedVoucher.giftName}
                        onChange={(e) => setSelectedVoucher({ ...selectedVoucher, giftName: e.target.value })}
                        className="w-full px-4 py-3 bg-blue-50/50 border border-blue-100 rounded-2xl focus:ring-2 focus:ring-blue-500 outline-none text-sm font-extrabold text-blue-700 transition-all placeholder:text-blue-200"
                        placeholder="VD: Chai khử mùi giày..."
                      />
                    </>
                  ) : (
                    <>
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Mã Voucher *</label>
                      <input
                        required
                        type="text"
                        value={selectedVoucher.code}
                        onChange={(e) => setSelectedVoucher({ ...selectedVoucher, code: e.target.value.toUpperCase() })}
                        className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-2xl focus:ring-2 focus:ring-blue-500 outline-none text-sm font-bold transition-all placeholder:text-slate-300"
                        placeholder="VD: BIGSALE50"
                      />
                    </>
                  )}
                </div>
              </div>

              {selectedVoucher.type !== "gift" && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 animate-fadeIn">
                  <div className="space-y-1.5">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Hình thức giảm</label>
                    <select
                      value={selectedVoucher.type}
                      onChange={(e) => setSelectedVoucher({ ...selectedVoucher, type: e.target.value })}
                      className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-2xl focus:ring-2 focus:ring-blue-500 outline-none text-sm font-bold text-slate-700 transition-all"
                    >
                      <option value="percent">Phần trăm (%)</option>
                      <option value="amount">Số tiền cố định (₫)</option>
                    </select>
                  </div>
                  <div className="space-y-1.5">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Giá trị giảm *</label>
                    <input
                      required
                      type="number"
                      value={selectedVoucher.value}
                      onChange={(e) => setSelectedVoucher({ ...selectedVoucher, value: e.target.value })}
                      className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-2xl focus:ring-2 focus:ring-blue-500 outline-none text-sm font-bold transition-all"
                    />
                  </div>
                </div>
              )}

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="space-y-1.5">
                  <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Đơn tối thiểu *</label>
                  <input
                    required
                    type="number"
                    value={selectedVoucher.minOrder}
                    onChange={(e) => setSelectedVoucher({ ...selectedVoucher, minOrder: e.target.value })}
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-2xl focus:ring-2 focus:ring-blue-500 outline-none text-sm font-bold transition-all"
                  />
                </div>
                <div className="space-y-1.5">
                  <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Số lượng cấp *</label>
                  <input
                    required
                    type="number"
                    value={selectedVoucher.quantity}
                    onChange={(e) => setSelectedVoucher({ ...selectedVoucher, quantity: e.target.value })}
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-2xl focus:ring-2 focus:ring-blue-500 outline-none text-sm font-bold transition-all"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="space-y-1.5">
                  <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Ngày bắt đầu</label>
                  <input
                    type="date"
                    value={selectedVoucher.startDate ? selectedVoucher.startDate.split("T")[0] : ""}
                    onChange={(e) => setSelectedVoucher({ ...selectedVoucher, startDate: e.target.value })}
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-2xl focus:ring-2 focus:ring-blue-500 outline-none text-sm font-bold text-slate-700 transition-all font-mono"
                  />
                </div>
                <div className="space-y-1.5">
                  <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Ngày hết hạn</label>
                  <input
                    required
                    type="date"
                    value={selectedVoucher.expiryDate ? selectedVoucher.expiryDate.split("T")[0] : ""}
                    onChange={(e) => setSelectedVoucher({ ...selectedVoucher, expiryDate: e.target.value })}
                    className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-2xl focus:ring-2 focus:ring-blue-500 outline-none text-sm font-bold text-slate-700 transition-all font-mono"
                  />
                </div>
              </div>

              <div className="flex gap-6 py-2 border-t border-gray-50 pt-6">
                <label className="flex items-center gap-3 cursor-pointer group">
                  <div className="relative">
                    <input
                      type="checkbox"
                      className="peer hidden"
                      checked={selectedVoucher.isActive}
                      onChange={(e) => setSelectedVoucher({ ...selectedVoucher, isActive: e.target.checked })}
                    />
                    <div className="w-10 h-5 bg-slate-200 peer-checked:bg-green-500 rounded-full transition-all duration-300"></div>
                    <div className="absolute left-1 top-1 w-3 h-3 bg-white rounded-full transition-all duration-300 peer-checked:left-6"></div>
                  </div>
                  <span className="text-[11px] font-black text-slate-500 uppercase tracking-widest">Kích hoạt ngay</span>
                </label>
                <label className="flex items-center gap-3 cursor-pointer group">
                  <div className="relative">
                    <input
                      type="checkbox"
                      className="peer hidden"
                      checked={selectedVoucher.isSpinPrize}
                      onChange={(e) => setSelectedVoucher({ ...selectedVoucher, isSpinPrize: e.target.checked })}
                    />
                    <div className="w-10 h-5 bg-slate-200 peer-checked:bg-amber-500 rounded-full transition-all duration-300"></div>
                    <div className="absolute left-1 top-1 w-3 h-3 bg-white rounded-full transition-all duration-300 peer-checked:left-6"></div>
                  </div>
                  <span className="text-[11px] font-black text-slate-500 uppercase tracking-widest">Quà vòng quay</span>
                </label>
              </div>

              {/* Action Buttons - Fixed for Mobile */}
              <div className="mt-auto pt-6 flex gap-3 flex-col sm:flex-row pb-6 sm:pb-0">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="w-full sm:flex-1 py-3.5 px-6 font-black text-xs sm:text-sm text-slate-400 uppercase tracking-widest hover:text-slate-600 transition-all bg-gray-50 rounded-2xl order-2 sm:order-1"
                >
                  Hủy bỏ
                </button>
                <button
                  type="submit"
                  className="w-full sm:flex-[2] py-3.5 sm:py-4 px-6 bg-slate-900 text-white rounded-2xl font-black text-xs sm:text-sm uppercase tracking-widest hover:bg-black active:scale-[0.98] transition-all shadow-xl shadow-slate-200 order-1 sm:order-2 flex items-center justify-center gap-2"
                >
                  <span className="material-symbols-outlined text-[20px]">task_alt</span>
                  Lưu Voucher
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Gift Modal - Responsive Drawer */}
      {showGiftModal && (
        <div className="fixed inset-0 z-[100] flex sm:items-center justify-center p-0 sm:p-4 bg-slate-900/60 backdrop-blur-sm overflow-hidden">
          <div className="bg-white w-full max-w-md h-full sm:h-auto sm:max-h-[85vh] sm:rounded-[32px] overflow-hidden shadow-2xl animate-modalUp flex flex-col">
            <div className="p-4 sm:p-6 bg-slate-900 text-white flex justify-between items-center shrink-0">
              <h3 className="text-sm sm:text-lg font-black uppercase tracking-widest flex flex-col">
                <span className="text-blue-400">Tặng Voucher</span>
                <span className="text-gray-400 text-[10px]">{selectedVoucher.code}</span>
              </h3>
              <button onClick={() => { setShowGiftModal(false); setSelectedUserForGift(null); }} className="w-10 h-10 rounded-full hover:bg-slate-800 flex items-center justify-center bg-slate-800">
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>
            
            <div className="p-4 sm:p-8 space-y-6 flex-1 overflow-y-auto no-scrollbar">
              <div className="space-y-1.5">
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Tìm người nhận</label>
                <div className="relative">
                  <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-300 text-[18px]">person_search</span>
                  <input
                    type="text"
                    value={searchUser}
                    onChange={(e) => {
                      setSearchUser(e.target.value);
                      handleSearchUser(e.target.value);
                    }}
                    className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-100 rounded-2xl focus:ring-2 focus:ring-blue-500 outline-none text-sm font-bold transition-all placeholder:text-slate-300"
                    placeholder="Tên hoặc Email..."
                  />
                  {loading && (
                    <div className="absolute right-3 top-1/2 -translate-y-1/2">
                      <div className="animate-spin rounded-full h-4 w-4 border-2 border-blue-600 border-t-transparent"></div>
                    </div>
                  )}
                </div>
              </div>

              {users.length > 0 && (
                <div className="bg-slate-50 rounded-[24px] overflow-hidden divide-y divide-gray-100 border border-slate-100 max-h-48 overflow-y-auto no-scrollbar">
                  {users.map((u) => (
                    <button
                      key={u._id}
                      onClick={() => setSelectedUserForGift(u)}
                      className={`w-full p-4 flex items-center justify-between transition-all ${
                        selectedUserForGift?._id === u._id ? "bg-blue-600 text-white" : "hover:bg-blue-50 text-slate-800"
                      }`}
                    >
                      <div className="text-left min-w-0">
                        <p className="text-xs font-black truncate">{u.name}</p>
                        <p className={`text-[10px] font-bold truncate ${selectedUserForGift?._id === u._id ? "text-blue-100" : "text-slate-400"}`}>{u.email}</p>
                      </div>
                      {selectedUserForGift?._id === u._id && <span className="material-symbols-outlined text-[18px]">check_circle</span>}
                    </button>
                  ))}
                </div>
              )}

              {selectedUserForGift && (
                <div className="bg-blue-50/50 p-5 rounded-[24px] border border-blue-100 flex items-center gap-4 animate-fadeIn">
                  <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-black text-lg shrink-0">
                    {selectedUserForGift.name?.charAt(0).toUpperCase()}
                  </div>
                  <div className="min-w-0">
                    <p className="text-[10px] font-black text-blue-400 uppercase tracking-widest">Đang chọn</p>
                    <p className="text-sm font-black text-blue-700 truncate">{selectedUserForGift.name}</p>
                  </div>
                </div>
              )}

              <div className="pt-6 border-t border-gray-100 mt-auto">
                <button
                  onClick={handleGiftVoucher}
                  disabled={!selectedUserForGift || gifting}
                  className="w-full py-4 bg-slate-900 text-white rounded-2xl font-black text-xs sm:text-sm uppercase tracking-widest hover:bg-black active:scale-[0.98] transition-all disabled:opacity-50 disabled:bg-slate-200 flex items-center justify-center gap-2 shadow-xl shadow-slate-200 mb-6 sm:mb-0"
                >
                  {gifting ? <span className="material-symbols-outlined animate-spin">refresh</span> : <span className="material-symbols-outlined text-[18px]">send</span>}
                  Xác nhận gửi voucher
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminVouchers;
